import { handleActions } from 'redux-actions';
import types from './types';

const initialState = {
  channels: [],
};

const subscribeToChannel = (state, action) => {
  const { channelId } = action.payload;
  return {
    ...state,
    channels: [...state.channels, channelId],
  };
};

const unsubscribeToChannel = (state, action) => {
  const { channelId } = action.payload;
  const newChannels = state.channels.filter(channel => channel !== channelId);
  return {
    ...state,
    channels: newChannels,
  };
};

const reducer = handleActions(
  {
    [types.SUBSCRIBE_TO_CHANNEL]: subscribeToChannel,
    [types.UNSUBSCRIBE_TO_CHANNEL]: unsubscribeToChannel,
  },
  initialState,
);

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/websockets/reducers.js